import React from 'react';
import {Route, Switch} from "react-router-dom";
import {inject} from 'mobx-react';
import SignIn from "components/new_user/SignIn";
import SignUp from "components/new_user/SignUp";
import Navbar from "components/new_user/NavBar";
import CarouselWrapper from "components/new_user/CarouselWrapper";
import ForgotPassword from './ForgotPassword';
import PasswordRecovery from './PasswordRecovery';

@inject("SponsorStore")
export default class NewUser extends React.Component {

  componentDidMount = () => {
    this.props.SponsorStore.redirectFromSponsor();
  }

  componentWillUnmount = () => {
    this.props.SponsorStore.clearFromSponsor();
  }

  render(){
    return(
      <div>
        <Navbar/>
        <main className="main-content">
          <div className="container-fluid">
            <div className="sign-up row">
              <div className="col-4 hide-xs hide-s">
                <CarouselWrapper/>
              </div>
              <div className="col-12 col-md-5">
                <Switch>
                  <Route path="/newuser/signin" component={SignIn}/>
                  <Route path="/newuser/signup" component={SignUp}/>
                  <Route path="/newuser/forgotpassword" component={ForgotPassword}/>
                  <Route path="/newuser/passwordrecovery/:token" component={PasswordRecovery}/>
                </Switch>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/new_user/NewUser.jsx